import { motion } from 'framer-motion';
import { ChevronLeft } from 'lucide-react';

interface BackButtonProps {
  onClick: () => void;
  label?: string;
}

export const BackButton = ({
  onClick,
  label = 'Back to Projects',
}: BackButtonProps) => (
  <motion.button
    whileHover={{ scale: 1.02 }}
    whileTap={{ scale: 0.98 }}
    onClick={onClick}
    className="group mb-6 flex items-center gap-2 px-4 py-2 rounded-full relative overflow-hidden
               border border-gray-200 dark:border-gray-700 hover:border-gray-300 
               dark:hover:border-gray-800 transition-all duration-300"
  >
    <div
      className="absolute inset-0 bg-gray-100 dark:bg-gray-800 transform 
                    translate-x-full group-hover:translate-x-0 transition-transform duration-300"
    />
    <ChevronLeft
      size={20}
      className="text-gray-600 dark:text-gray-400 relative z-10
                 transform transition-transform group-hover:-translate-x-1"
    />
    <span className="font-medium text-gray-700 dark:text-gray-300 relative z-10">
      {label}
    </span>
  </motion.button>
);
